import { useFilterOptionsClient } from "@domains/reviews/client/api/filterOptionsQuery.ts";
import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const NO_LABELS = new Map<string, string>();

export function useCycleLabels(cycleIds: string[], language: string): Map<string, string> {
    const client = useFilterOptionsClient();
    const ids = useMemo(() => [...new Set(cycleIds)].toSorted(), [cycleIds]);

    const options = client.searchReviewCycles.queryOptions({ input: { restrictToReviewCycleIds: ids, pageSize: ids.length || 1 } });

    const { data } = useQuery(
        createQueryOptions(options, {
            queryKey: [...options.queryKey, { language }],
            enabled: ids.length > 0,
            throwOnError: false
        })
    );

    return useMemo(() => (data ? new Map(data.items.map(cycle => [cycle.id, cycle.label])) : NO_LABELS), [data]);
}
